import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

import { useFormsTemplatesContext } from '../formsTemplatesContext';

type FormsTemplatesExitModalButtonsProps = {
   readonly onCancel: VoidFunction;
};

export const FormsTemplatesExitModalButtons = (props: FormsTemplatesExitModalButtonsProps): JSX.Element | null => {
   const { mode } = useFormsTemplatesContext();

   if (mode === 'EDIT') {
      return null;
   }
   return (
      <>
         <ModalCloseButton onClick={props.onCancel} />
         <ModalCancelButton onClick={props.onCancel} />
      </>
   );
};
